<template>
  <div>file include</div>
</template>

<script>
export default {};
</script>

<style>
</style>